/**
 * One colour scheme for court events, everywhere they appear.
 *
 * This lived inside CalendarEditable, which meant the calendar Kelsi works from and every other
 * place a court date is shown agreed by coincidence rather than by construction — and they did not
 * agree. Lloyd, Aug 18: "For court dates, can you color code them to match what Kelsi has for the
 * Calendar view?" Moving the function here is the whole of that change; the calendar keeps its
 * exact colours and the rest of the app now borrows them instead of inventing its own.
 *
 * Colour by hearing type. Order matters: "pretrial" contains "trial", so the old rule painted every
 * pretrial the same red as a jury trial — the two settings a calendar most needs to tell apart.
 * Reminder rows ("10 Day Warning") are deliberately muted: they are not a court date.
 * Colours are the solid 700-level MUI palette so white text clears WCAG AA.
 */

export const COURT_EVENT_COLOR_KEY: { label: string; color: string }[] = [
  { label: 'Pre-trial', color: '#6a1b9a' },
  { label: 'Trial', color: '#c62828' },
  { label: 'Docket', color: '#00695c' },
  { label: 'Arraignment', color: '#283593' },
  { label: 'Hearing', color: '#ef6c00' },
  { label: 'Meeting', color: '#2e7d32' },
  { label: 'Reminder', color: '#5f6368' },
  { label: 'Other', color: '#1565c0' },
];

export function courtEventColor(rawTitle: string | null | undefined): string {
  const title = (rawTitle ?? '').toLowerCase();
  if (title.includes('warning') || title.includes('waring')) return '#5f6368'; // grey — reminder
  if (title.includes('pretrial') || title.includes('pre-trial')) return '#6a1b9a'; // purple
  if (title.includes('trial')) return '#c62828'; // red — jury/bench trial
  if (title.includes('docket')) return '#00695c'; // teal
  if (title.includes('arraign')) return '#283593'; // indigo
  if (title.includes('hearing')) return '#ef6c00'; // orange
  if (title.includes('meeting')) return '#2e7d32'; // green
  return '#1565c0'; // default blue
}
